import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 theme-app-bg z-50 flex items-center justify-center">
      <div className="flex flex-col items-center space-y-4">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-lg theme-text-secondary">Loading your workspace...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;